import React from 'react';

import MotionMedia from './MotionMedia';
import { BEARRI_MOTION, BearriMotionName } from './motionAssets';

export type BearriMotionProps = {
  name: BearriMotionName;
  mode?: 'loop' | 'cue';
  playing?: boolean;
  className?: string;
  style?: React.CSSProperties;
  priority?: boolean;
};

const BearriMotion: React.FC<BearriMotionProps> = ({ name, ...props }) => (
  <MotionMedia asset={BEARRI_MOTION[name]} {...props} />
);

export default BearriMotion;
